import Axios from 'axios';
import { ERROR_STRING_COLOR } from '../utilities/constants/Constants';
import { string } from '../localization';
import actions from '../redux/actionTypes';

const interceptor = store => {
  Axios.interceptors.response.use(null, error => {
    let descriptionMessage = '';
    // check if generate_openai_image api
    try {
      if (
        error.config.url.includes(
          'content/user_photos/generate_openai_image'
        ) &&
        error.response.status == 400
      ) {
        descriptionMessage = error.response.response;
      } else {
        descriptionMessage = error.response.statusText;
      }
    } catch (err) {
      console.log('');
    }

    const dict = {
      header: `${error.response.status} Error!`,
      description: descriptionMessage,
      stringColor: ERROR_STRING_COLOR,
      onclick: null,
      buttonTitles: { finish: string.OK_KEY, cancel: '' }
    };

    store.dispatch({
      type: actions.SET_DIALOGUE_PARAMS,
      payload: {
        info: dict
      }
    });
    store.dispatch({
      type: actions.SET_DIALOGUE_FLAG,
      payload: {
        dialogueFlag: true
      }
    });

    store.dispatch({
      type: actions.SET_SAVE_STATE,
      payload: {
        loadingState: null,
        loadingCount: -1
      }
    });
    return Promise.reject(error);
  });
};

export default {
  interceptor
};
